//actions for managing sidebar open and close 
export const open=()=>{
    return {
        type:"OPEN"
    }
}
export const close=()=>{
    return {
        type:"CLOSE"
    }
}

//actions for project data manipulations
export const ADD_PROJECT = "ADD_PROJECT";

export const addProject = (project) => ({
  type: ADD_PROJECT,
  payload: project,
});
